import { families } from './families';
import { componentFamily } from './config';

export function resolveComponent(name) {
    const familyName = componentFamily[name];
    const Component = families[familyName]?.[name];
    if (!Component) {
        throw new Error(`No component "${name}" in family "${familyName}"`);
    }
    return Component;
}
